import { Descriptions as AntdDescriptions, DescriptionsProps } from 'antd'

const contentStyle = { whiteSpace: 'pre-wrap' }

const Descriptions = (props: DescriptionsProps) => (
  <AntdDescriptions {...props} contentStyle={contentStyle} />
)

export default Descriptions
